import React from 'react';
import ForecastChart from './ForecastChart';
import { dateFormatter, numberFormatter } from '../../common/formatter';
import ReportDescription from '../ReportDescription';
import styles from './Forecast.module.scss';

export default function Forecast({forecastSummary, weeklyForecast, monthlyForecast}){
    const foreCastIsReady = forecastSummary && weeklyForecast && monthlyForecast;
    return foreCastIsReady ?
        (<div>
            <h1 className='font-secondary font-weight-500 font-size-24 text-color-dark-grey'>Forecast</h1>
            <div className={styles.forecastSummary}>
                <ForecastHeader name={dateFormatter.getTodayLongMonth()} amount={forecastSummary.monthlyTotal} totalVideos={forecastSummary.monthlyPublicationCount} />
                <ForecastHeader name='this week' amount={forecastSummary.weeklyTotal} totalVideos={forecastSummary.weeklyPublicationCount} />
            </div>
            <ForecastChart 
                title='Monthly estimate' 
                tooltipText='How much budget is already scheduled and published for the month' 
                forecasts={monthlyForecast}
            />
            <ForecastChart 
                title='Weekly estimate' 
                tooltipText='How much budget is already scheduled and published every week'
                forecasts={weeklyForecast}
            />
        </div>) : null;


}

function ForecastHeader({name, amount, totalVideos}){
    const pluralized = totalVideos === 1 ? '' : 's';
    return (
        <ReportDescription header={`Expected publications ${name}`}
                    content={(
                    <span>{numberFormatter.formatAsCurrency(amount, 0)}</span>)}
                    footer={<span>{`${totalVideos} video${pluralized}`}</span>} />
                );
}